<template>
  <div class="xin">
    <div class="switch">
      <el-tabs  @tab-click="dianji">
        <!-- 硬盘信息 -->

        <el-tab-pane label="数据统计" >
          <span slot="label">
            {{ $t("logs.sysyem_menu1") }}
          </span>
          <div class="switch1">
            <!-- 查询框 -->
            <div class="main" v-loading="loading1">
              <div class="main-find">
                <span class="span">{{ this.has_min1 }}</span>

                <el-select
                  v-model="salt_minion_ip_disk"
                  placeholder="按天统计"
                  @change="change1"
                  v-if="this.has_minion == 1"
                >
                  <el-option
                    v-for="item in salt_minion_ip_disk_arr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- 弹出框2-->

            <!--  表格 -->
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList1"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <el-table-column prop="NAME" :label="this.disk_name">
                </el-table-column>
                <el-table-column prop="QUATO" :label="this.disk_quato">
                </el-table-column>
                <el-table-column prop="USED" :label="this.disk_used">
                </el-table-column>
                <el-table-column prop="AVAIL" :label="this.disk_avail">
                </el-table-column>
                <el-table-column prop="USERD_1" :label="this.disk_used_persent">
                </el-table-column>
                <el-table-column prop="MOUNT" :label="this.disk_mount">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <!-- 系统进程  -->

        <el-tab-pane label="数据统计">
          <span slot="label">
            {{ $t("logs.sysyem_menu2") }}
          </span>
          <div class="switch1">
            <!-- 查询框 -->
            <div class="main" v-loading="loading1">
              <div class="main-find">
                <span class="span">{{ this.has_min2 }}</span>

                <el-select
                  v-model="salt_minion_ip_proc"
                  placeholder="按天统计"
                  @change="change2"
                  v-if="this.has_minion == 1"
                >
                  <el-option
                    v-for="item in salt_minion_ip_proc_arr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- 弹出框2-->

            <!--  表格 -->
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList2"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <el-table-column prop="USER" :label="this.process_owner">
                </el-table-column>
                <el-table-column prop="PID" :label="this.process_pid">
                </el-table-column>
                <el-table-column prop="CPU" :label="this.process_cpu">
                </el-table-column>
                <el-table-column prop="MEM" :label="this.process_mem">
                </el-table-column>
                <el-table-column prop="VSZ" :label="this.process_vsz">
                </el-table-column>
                <el-table-column prop="RSS" :label="this.process_rss">
                </el-table-column>
                <el-table-column prop="START" :label="this.process_start">
                </el-table-column>
                <el-table-column prop="TIME" :label="this.process_time">
                </el-table-column>
                <el-table-column prop="COMMAND" :label="this.process_commond">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <!-- 处理器及内存信息  -->

        <el-tab-pane label="数据统计">
          <span slot="label">
            {{ $t("logs.sysyem_menu3") }}
          </span>
          <div class="switch1">
            <!-- 查询框 -->
            <div class="main" >
              <div class="main-find">
                <span class="span">{{ $t('logs.processor')}}</span>

                <el-select
                  v-model="salt_minion_ip_cpuinfo"
                  placeholder="按天统计"
                  @change="change3"
                  v-if="this.has_minion == 1"
                  style="30%"
                >
                  <el-option
                    v-for="item in salt_minion_ip_cpuinfo_arr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                  <el-button
                  @click="refresh_info()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t('confirm.refresh')}}</el-button
                >
              </div>
            </div>
            <!-- 弹出框2-->

            <!--  表格 -->
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList3"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <el-table-column
                  prop="CPU_TYPE"
                  :label="this.cpu_type"
                  width="260"
                >
                </el-table-column>
                <el-table-column
                  prop="CPU_USED"
                  :label="this.cpu_used"
                  width="140"
                >
                </el-table-column>
                <el-table-column prop="CPU_NUM" :label="this.cpu_num">
                </el-table-column>
                <el-table-column prop="UPTIME" :label="this.uptime" width="120">
                </el-table-column>
                <el-table-column prop="MEM_TOTAL" :label="this.mem_total">
                </el-table-column>
                <el-table-column prop="MEM_USED" :label="this.mem_used">
                </el-table-column>
                <el-table-column prop="MEM_FREE" :label="this.mem_free">
                </el-table-column>
                <el-table-column prop="MEM_CASH" :label="this.mem_cash">
                </el-table-column>
                <el-table-column prop="SWAP_CASH" :label="this.swap_cash">
                </el-table-column>
                <el-table-column
                  prop="SWAP_TOTAL"
                  :label="this.swap_total"
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="SWAP_USED"
                  :label="this.swap_used"
                  width="140"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <!-- 版本管理  -->

        <el-tab-pane label="版本管理">
          <span slot="label">
            {{ $t("logs.sysyem_menu4") }}
          </span>
          <div class="switch1">
            <!--  -->
            <div class="main" v-loading="loading1">
              <div class="main-find">
                <span class="span">{{ this.has_min4 }}</span>

                <el-button
                  @click="daoru()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ this.input_hint2 }}</el-button
                >

                <!-- 备份配置-->

                <el-button
                  @click="daochu()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ this.input_hint1 }}</el-button
                >
              </div>
            </div>
            <!-- 弹出框2-->
            <div
              class="pop-up"
              v-show="tanchu_to_ip"
              v-drag="{ handle: '.pop_up_text_import_iup' }"
            >
              <div class="pop_up_text pop_up_text_import_iup">
                <span style="padding: 0 14px"></span>{{ this.input_hint2 }}
              </div>
              <p></p>
              <div class="find" v-loading="loading">
                <div class="find1">
                  <div class="block block1">
                    <input
                      type="file"
                      @change="inputFileChange"
                      id="iupfile_ip"
                      ref="clearFile"
                      accept=".gz"
                    />
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" size="mini" @click="save022">{{
                  $t("tan.up")
                }}</el-button>
                <el-button type="danger" @click="save23()">{{
                  $t("tan.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_to_ip"></div>
            <!--  表格 -->
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList4"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <el-table-column prop="VERSION" :label="this.fileList4_title">
                </el-table-column>

                n>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <!-- 规则及库管理  -->

        <el-tab-pane label="数据统计">
          <span slot="label">
            {{ $t("logs.sysyem_menu5") }}
          </span>
          <div class="switch1">
            <!-- 查询框 -->
            <div class="main" v-loading="loading1">
              <div class="main-find">
                <span class="span">{{ this.has_min5 }}</span>

                <el-select
                  v-model="salt_minion_ip_ruleup"
                  placeholder="按天统计"
                  @change="change5"
                  v-if="this.has_minion == 1"
                  style="30%"
                >
                  <el-option
                    v-for="item in salt_minion_ip_ruleup_arr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- 弹出框2-->

            <!--  表格 -->
            <div class="table table_first">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList5"
                :row-class-name="tableRowClassName"
                v-loading="loading"
                :cell-class-name="tableCellClassName"
              >
                <el-table-column
                  prop="NAME"
                  :label="this.library_name"
                  width="260"
                >
                </el-table-column>
                <el-table-column
                  prop="STATUS"
                  :label="this.library_update_status"
                >
                </el-table-column>
                <el-table-column
                  prop="UPDATE_TIME"
                  :label="this.library_update_time"
                >
                </el-table-column>
                <el-table-column
                  prop="FAIL_TIME"
                  :label="this.library_fail_time"
                >
                </el-table-column>
              </el-table>
            </div>
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList5_2"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <el-table-column
                  prop="UPDATE_DAY"
                  :label="this.library_update_day"
                  width="260"
                >
                </el-table-column>
                <el-table-column
                  prop="COUNT"
                  :label="this.library_update_count"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <!-- 历史信息 -->

        <el-tab-pane label="数据统计">
          <span slot="label">
            {{ $t("logs.sysyem_menu6") }}
          </span>
          <div class="switch1">
            <!-- 弹出框2-->

            <!--  表格 -->
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList6"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <el-table-column prop="HOST" :label="this.host" width="120">
                </el-table-column>
                <el-table-column
                  prop="STARTTIME"
                  :label="this.fmilter_start_time"
                  width="180"
                >
                </el-table-column>
                <el-table-column
                  prop="RUNDAYS"
                  :label="this.fmilter_run_days"
                  width="180"
                >
                </el-table-column>
                <el-table-column
                  prop="TOTAL_CONN"
                  :label="this.fm_new_stat_CONNECT"
                >
                </el-table-column>
                <el-table-column
                  prop="TOTAL_MSGS"
                  :label="this.fm_new_stat_MSGS"
                >
                </el-table-column>
                <el-table-column
                  prop="TOTAL_RCPT"
                  :label="this.fm_new_stat_ENVTO"
                >
                </el-table-column>
                <el-table-column
                  prop="TOTAL_BYTES"
                  :label="this.fm_new_stat_BYTES"
                >
                </el-table-column>
                <el-table-column
                  prop="TOTAL_FILES"
                  :label="this.fm_new_stat_FILES"
                >
                </el-table-column>
                <el-table-column
                  prop="TOTAL_XFILES"
                  :label="this.fm_new_stat_XFILES"
                  width="160"
                >
                </el-table-column>
                <el-table-column
                  prop="TOTAL_VIRUS"
                  :label="this.fm_new_stat_VIRUS"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 查询框 -->

    <!--  底部 -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 历史信息
      fm_new_stat_BYTES: "",
      fm_new_stat_CONNECT: "",
      fm_new_stat_ENVTO: "",
      fm_new_stat_FILES: "",
      fm_new_stat_MSGS: "",
      fm_new_stat_VIRUS: "",
      fm_new_stat_XFILES: "",
      fmilter_run_days: "",
      fmilter_start_time: "",
      host: "",

      // 规则及库管理
      library_fail_time: "",
      library_name: "",
      library_update_count: "",
      library_update_day: "",
      library_update_status: "",
      library_update_time: "",
      // 处理器及内存信息
      dafault_time:5000,
      cpu_num: "",
      cpu_type: "",
      cpu_used: "",
      mem_cash: "",
      mem_free: "",
      mem_total: "",
      swap_cash: "",
      swap_total: "",
      swap_used: "",
      uptime: "",
      mem_used: "",
      //系统进程
      process_owner: "",
      process_commond: "",
      process_cpu: "",
      process_mem: "",
      process_pid: "",
      process_rss: "",
      process_start: "",
      process_time: "",
      process_vsz: "",
      // 硬盘信息
      disk_avail: "",
      disk_mount: "",
      disk_name: "",
      disk_quato: "",
      disk_used: "",
      disk_used_persent: "",
      has_minion: "",
      has_min1: "",
      has_min2: "",
      has_min3: "",
      has_min4: "",
      has_min5: "",
      fileList4_title: "",
      salt_minion_ip_disk: "127.0.0.1",
      salt_minion_ip_proc: "127.0.0.1",
      salt_minion_ip_cpuinfo: "127.0.0.1",
      salt_minion_ip_ruleup: "127.0.0.1",
      salt_minion_ip_cpuinfo1: "127.0.0.1",
      salt_minion_ip_disk_arr: [],
      salt_minion_ip_proc_arr: [],
      salt_minion_ip_cpuinfo_arr: [],
      salt_minion_ip_ruleup_arr: [],
      xian: false,
      btnText: "展示更多",
      checked: "",
      form: {
        username: "",
      },
      value: "",

      tanchu: false,
      options: [
        {
          value: "选项1",
          label: "按天统计",
        },
        {
          value: "选项2",
          label: "按周统计",
        },
        {
          value: "选项3",
          label: "按月统计",
        },
        {
          value: "选项4",
          label: "按年统计",
        },
      ],
      version_show: "",
      input_hint1: "",
      input_hint2: "",
      emali: "",
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      fileList5_2: [],
      fileList6: [],
      loading: false,
      loading1: false,
      tanchu_to_ip: false,
      files: "",
      tab_num_daf:'',
    };
  },
  mounted() {
    this.getFileList1();
    this.getFileList2();
    this.getFileList3();
    this.getFileList4();
    this.getFileList5();
    this.getFileList6();
  },
  //   beforeDestroy() {
  //   clearInterval(this.timer_flush);
  //   this.timer_flush = null;
  // },
  methods: {
    refresh_info(){
  this.getFileList3();

    },
     dianji(a) {
      
            console.log(a.index)
            this.tab_num_daf=a.index;
          // if(a.index==2){
          //    this.getFileList3();
        //      this.timer_flush = setInterval(() => {
        //   setTimeout(this.getFileList3(), 0);
        // }, this.dafault_time);
          // }
      //      else {
      //   clearInterval(this.timer_flush);
      //   this.timer_flush = null;
      // }
           

        },
    inputFileChange(e) {
      this.files = e.target.files[0];
      // console.log(this.files);
    },
    // 白名单增加
    save022() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);

      let iupfile = this.files;
      // console.log(iupfile);
      // 判断是否有文件
      if (0 == this.files.length) {
        this.$message({
          type: "info",
          message: "请选择要上传的文件",
        });
        return;
      } else {
        this.loading = true;
        let fd = new FormData();
        fd.append("iupfile", iupfile);
        // for (var i = 0; i < this.files.length; i++) {
        //     fd.append('fileUpload', this.files[i]);
        // }
        fd.append("__mode", "upload_recover_cfg");
        fd.append("sid", sid);
        // console.log(fd);
        this.$axios({
          method: "post",
          url: "/api/adm/cgi/newspam.cgi",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: fd,
        }).then((res) => {
          console.log(res);
          this.loading = false;
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu = false;

            this.getFileList4();
            this.$refs.clearFile.value = ""; // 清空file文件
            this.files = "";
            // console.log(this.files)
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.del3")}`,
            });
            this.tanchu_to_ip = false;
          }
        });
      }
    },
    save23() {
      this.tanchu_to_ip = false;
    },
    daoru() {
      this.tanchu_to_ip = true;
      document.getElementById("iupfile_ip").value = "";
    },
    daochu() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let __mode = "backup_cfg";
      // console.log(__mode);

      // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
      window.open(`/api/adm/cgi/mon.cgi?__mode=${__mode}&sid=${sid}`);
    },
    // 判断状态变色
    tableCellClassName({ row }) {
      // console.log(row, rowIndex);

      if (row.OK == 1) {
        return "sent1";
      } else if (row.OK == 0) {
        return "sent2";
      }
      return "";
    },
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },
    // 数据统计加载
    getFileList6() {
      this.loading = true;
      // this.loading1 = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "show_history_stat",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            // this.loading1 = false;
            if (res.data.ret.HAS_MINION) {
              this.has_minion = 1;
            }
            this.fileList6 = res.data.ret.datalist;
            // this.fileList5_2 = res.data.ret.digestlist;
            // this.has_min5 = res.data.ret.LOAD_HINT;
            this.host = res.data.ret.host;
            this.fmilter_start_time = res.data.ret.fmilter_start_time;
            this.fm_new_stat_XFILES = res.data.ret.fm_new_stat_XFILES;
            this.fmilter_run_days = res.data.ret.fmilter_run_days;
            this.fm_new_stat_VIRUS = res.data.ret.fm_new_stat_VIRUS;
            this.fm_new_stat_MSGS = res.data.ret.fm_new_stat_MSGS;
            this.fm_new_stat_FILES = res.data.ret.fm_new_stat_FILES;
            this.fm_new_stat_ENVTO = res.data.ret.fm_new_stat_ENVTO;
            this.fm_new_stat_CONNECT = res.data.ret.fm_new_stat_CONNECT;
            this.fm_new_stat_BYTES = res.data.ret.fm_new_stat_BYTES;

            // this.salt_minion_ip_ruleup_arr = res.data.ret.q_minion_host;
          }
        });
    },
    // 数据统计加载
    getFileList5() {
      this.loading = true;
      this.loading1 = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "show_rule_manage",
            sid: sid,
            salt_minion_ip: this.salt_minion_ip_ruleup,
          },
        })
        .then((res) => {
          console.log(res, "444");

          if (!res) {
            this.loading = false;
            this.loading1 = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            // alert(res.data.fmstatus.errmsg);
            this.loading = false;
            this.loading1 = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.loading1 = false;
            if (res.data.ret.HAS_MINION) {
              this.has_minion = 1;
            }
            this.fileList5 = res.data.ret.rulelist;
            console.log(this.fileList5, "474");
            this.fileList5_2 = res.data.ret.digestlist;
            this.has_min5 = res.data.ret.LOAD_HINT;
            this.library_fail_time = res.data.ret.library_fail_time;
            this.library_name = res.data.ret.library_name;
            this.library_update_count = res.data.ret.library_update_count;
            this.library_update_day = res.data.ret.library_update_day;
            this.library_update_status = res.data.ret.library_update_status;
            this.library_update_time = res.data.ret.library_update_time;

            this.salt_minion_ip_ruleup_arr = res.data.ret.q_minion_host;
          }
        });
    },
    // 下拉框点击选中
    change5(a) {
      // console.log(a);
      this.salt_minion_ip_ruleup = a;
      this.getFileList5();
      this.loading1 = false;
    },
    getFileList4() {
      this.loading = true;
      this.loading1 = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "show_version",
            sid: sid,
            tochkver: 1,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
            this.loading1 = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.loading1 = false;

            this.fileList4 = res.data.ret.datalist;
            this.fileList4_title = res.data.ret.LOAD_HINT_TEXT;
            this.has_min4 = res.data.ret.LOAD_HINT;
            this.version_show = res.data.ret.ok;
            this.input_hint1 = res.data.ret.LOAD_INPUT_HINT1;
            this.input_hint2 = res.data.ret.LOAD_INPUT_HINT2;
          }
        });
    },
    //处理器及内存信息
    getFileList3() {
      this.loading = true;
      this.loading1 = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "show_cpuinfo",
            sid: sid,
            salt_minion_ip: this.salt_minion_ip_cpuinfo,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
            this.loading1 = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.loading1 = false;
            if (res.data.ret.HAS_MINION) {
              this.has_minion = 1;
            }
            this.fileList3 = res.data.ret.datalist;
            this.has_min3 = res.data.ret.LOAD_HINT;
            this.mem_free = res.data.ret.mem_free;
            this.mem_cash = res.data.ret.mem_cash;
            this.mem_total = res.data.ret.mem_total;
            this.mem_used = res.data.ret.mem_used;
            this.swap_cash = res.data.ret.swap_cash;
            this.swap_total = res.data.ret.swap_total;
            this.swap_used = res.data.ret.swap_used;
            this.uptime = res.data.ret.uptime;
            this.cpu_num = res.data.ret.cpu_num;
            this.cpu_type = res.data.ret.cpu_type;
            this.cpu_used = res.data.ret.cpu_used;
            this.salt_minion_ip_cpuinfo=res.data.ret.salt_minion_ip;
            this.salt_minion_ip_cpuinfo_arr=res.data.ret.q_minion_host;
            // this.dafault_time=1000*6;

        }

        });
    },
    // 下拉框点击选中
    change3(a) {
      // console.log(a);
      this.salt_minion_ip_cpuinfo = a;
      this.getFileList3();
      this.loading1 = false;
    },
    // 数据统计加载
    getFileList2() {
      this.loading = true;
      this.loading1 = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "show_allproc",
            sid: sid,
            salt_minion_ip: this.salt_minion_ip_proc,
          },
        })
        .then((res) => {
          console.log(res);
          if (!res) {
            this.loading = false;
            this.loading1 = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            // alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.loading1 = false;
            if (res.data.ret.HAS_MINION) {
              this.has_minion = 1;
            }
            this.fileList2 = res.data.ret.datalist;
            this.has_min2 = res.data.ret.LOAD_HINT;
            this.process_owner = res.data.ret.process_owner;
            this.process_commond = res.data.ret.process_commond;
            this.process_cpu = res.data.ret.process_cpu;
            this.process_mem = res.data.ret.process_mem;
            this.process_pid = res.data.ret.process_pid;
            this.process_rss = res.data.ret.process_rss;
            this.process_start = res.data.ret.process_start;
            this.process_time = res.data.ret.process_time;
            this.process_vsz = res.data.ret.process_vsz;

            this.salt_minion_ip_proc_arr = res.data.ret.q_minion_host;
          }
        });
    },
    // 下拉框点击选中
    change2(a) {
      // console.log(a);
      this.salt_minion_ip_proc = a;
      this.getFileList2();
      this.loading1 = false;
    },
    // 数据统计加载
    getFileList1() {
      this.loading = true;
      this.loading1 = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "show_disk_status",
            sid: sid,
            salt_minion_ip: this.salt_minion_ip_disk,
          },
        })
        .then((res) => {
          console.log(res);
          if (!res) {
            this.loading = false;
            this.loading1 = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            // alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.loading1 = false;
            if (res.data.ret.HAS_MINION) {
              this.has_minion = 1;
            }
            this.fileList1 = res.data.ret.datalist;
            this.has_min1 = res.data.ret.LOAD_HINT;
            this.disk_avail = res.data.ret.disk_avail;
            this.disk_mount = res.data.ret.disk_mount;
            this.disk_name = res.data.ret.disk_name;
            this.disk_quato = res.data.ret.disk_quato;
            this.disk_used = res.data.ret.disk_used;
            this.disk_used_persent = res.data.ret.disk_used_persent;

            this.salt_minion_ip_disk_arr = res.data.ret.q_minion_host;
          }
        });
    },
    // 下拉框点击选中
    change1(a) {
      // console.log(a);
      this.salt_minion_ip_disk = a;
      this.getFileList1();
      this.loading1 = false;
    },
    // 打开关闭
    tanSend: function () {
      this.tanchu = false;
      this.tanchu1 = false;
    },
    tan4: function () {
      this.tanchu = true;
      //   this.tanchu1 = false;
    },
    tanOff: function () {
      this.tanchu = false;
      //   this.tanchu1 = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";

.table_first {
  .el-table {
    height: auto;
  }
}

.main-find {
  width: 100%;
  height: 42px;
  padding-left: 10px;
  // padding-bottom: 5px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: left;

  border: 2px solid #d2d7e6;
  background: #ffffff;

  span {
    margin-right: 8px;

    // width: 126px;
    // display: inline-block;
    color: #0e2c5e;
  }

  .el-input {
    margin-right: 8px;
    width: 20%;
    line-height: 26px;
    height: 26px;
    // padding: 5px 10px 5px 0;
  }

  // input 框高度
  /deep/ .el-input__inner {
    height: 32px;
    padding: 0 6px;
  }

  /deep/ .el-input--suffix {
    width: 170px;
    margin-right: 10px;
  }

  /deep/ .el-button {
    margin-right: 10px;
    margin-left: 20px;
  }
}

/deep/ .sent2 .cell {
  color: #f00 !important;
}
</style>
